<style lang="less">
    @import "../vars";

    .page-index {
        .mask{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            opacity: 0;
            z-index: 10;
        }
        .index {
            position: relative;
            z-index: 9;
            padding: 0 6pt;

            .privacy-statement-container {
            }

            .privacy-statement-container.in-app {
                padding-top: 0
            }

            .privacy-statement-container .tdac td {
                text-align: center
            }

            .privacy-statement-container .ps-content {
                color: #666;
                font-size: 13px;
                font-family: PingFangSC-Regular, Microsoft yahei;
                line-height: 1.5;
            }

            .privacy-statement-container .ps-content p {
                padding-bottom: .13333333rem;
                text-indent: 2em
            }

            .privacy-statement-container .ps-content dl dt {
                color: #333;
                font-weight: 700
            }

            .privacy-statement-container .ps-content dl.outer dt {
                padding: .4rem 0 0;
                text-align: left
            }

            .privacy-statement-container .ps-content dl dd {
                text-indent: 2em;
                padding-top: .13333333rem;
                text-align: justify;
                margin-inline-start:0;
                line-height: 26px;
            }

            .privacy-statement-container .ps-content dl dd thead td {
                text-align: center;
                white-space: nowrap
            }

            .privacy-statement-container .ps-content dl dd td {
                text-indent: 0;
                padding: .08rem;
                word-wrap: break-word;
                word-break: break-all
            }

            .privacy-statement-container .ps-content h2 {
                text-align: left;
                font-size: .42666667rem;
                font-weight: 700
            }

            .privacy-statement-container .ps-content h1 {
                text-align: center;
                font-size: .48rem;
                font-weight: 700
            }

            .privacy-statement-container .ps-content .col_yel {
                color: #fabe00
            }

            .privacy-statement-container .ps-content a {
                color: #2b99ff;
                text-decoration: none;
                position: relative;
                z-index: 99;
                display: block;
            }

            .privacy-statement-container .ps-content .pl20 {
                padding-left: .53333333rem
            }

            .privacy-statement-container .indent2 {
                text-indent: 2em
            }

            .title {
                font-weight: bold;
                text-align: center;
            }
            .tip{
                font-size: 12px;
                text-align: center;
            }
        }
    }
</style>
<template>
    <div class="page-index">
        <div class="index">
            <div id="box_captain">
                <p class="title">摩托宝用户隐私协议</p>
                <p class="tip">更新日期:2023年04月24日</p>
            </div>
            <div id="root">
                <div class="main">
                    <div class="privacy-statement-container">
                        <article class="ps-content">
                            <div>
                                <p style="text-indent: 2em;">欢迎使用由北京万事成汽车装饰有限公司及其关联公司提供的产品及服务，我们尊重并保护所有使用服务用户的个人隐私权。
                                    我们会按照本隐私权政策的规定使用和披露您的个人信息。
                                    我们将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，
                                    我们不会将这些信息对外披露或向第三方提供。我们会不时更新本隐私权政策。您在同意我们服务使用协议之时，
                                    即视为您已经同意本隐私权政策全部内容。本隐私权政策属于我们服务使用协议不可分割的一部分。 </p>
                                <p>
                                    <b>在您使用摩托宝各项产品或服务前，请您务必仔细阅读并透彻理解本声明，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</b>
                                    如果您不同意本隐私保护声明的任何内容，您应该立即停止使用。当您开始使用摩托宝平台，即表示您已经同意我们按照本隐私保护声明来收集、保存、使用、共享、保护您的个人信息。
                                </p>
                                <p>
                                    <b>在您使用摩托宝各项产品或服务前，我们为了平台的正常运行，收集到了您的个人信息。如果您不需要我们的产品或服务，请通过本隐私保护声明中所述的联系方式告知我们，我们会按照本声明所述删除或匿名化处理与您相关的个人信息。</b>
                                </p>
                                <p>摩托宝的用户隐私保护声明目录如下：</p>
                                <p>一、 个人信息的定义与范围</p>
                                <p>二、 我们向您收集个人信息的方式</p>
                                <p>三、 设备权限调用</p>
                                <p>四、 Cookie和同类技术</p>
                                <p>五、 您对个人信息的管理</p>
                                <p>六、 我们如何共享、转让、公开披露您的信息</p>
                                <p>七、 如何保护您的个人信息</p>
                                <p>八、 您的信息如何在全球范围转移</p>
                                <p>九、 我们如何处理未成年人的信息</p>
                                <p>十、 变更</p>
                                <p>十一、 如何联系我们</p>
                                <dl class="outer">
                                    <dt>一、 个人信息的定义与范围</dt>
                                    <dd>
                                        <b>个人信息指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。在本隐私保护声明中包括：姓名、手机号码、身份信息、照片、性别、年龄、职业信息、征信信息、驾驶证、电子邮箱、常用地址、通讯地址、紧急联系人、位置信息、通话记录、录音信息、网络状态、电量信息、订单信息及交易状态、评价信息、支付信息、银行卡号、日志信息、设备信息、设备IMEI/
                                            android ID、MAC地址、本机应用列表、历史浏览记录、IP地址、设备型号、设备标识符、操作系统版本、积分商城兑换记录等。</b>
                                    </dd>
                                    <dd>
                                        <b>个人敏感信息，是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或受到歧视性待遇等的个人信息，在本隐私保护声明中包括：姓名、身份证或其他身份证明、面部识别特征、手机号码、用户密码、驾驶证、位置信息、行程信息、通话记录、录音录像信息、照片数据、征信信息、支付信息、银行卡号。</b>
                                    </dd>
                                    <dd>匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，匿名化处理后的信息不属于个人信息。</dd>
                                    <dd>其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。</dd>
                                </dl>
                                <dl class="outer">
                                    <dt>二、 我们向您收集个人信息的方式</dt>
                                    <dd>
                                        <b>1.您向我们提供的信息</b>
                                    </dd>
                                    <dd>
                                        <b>为了遵守法律法规的要求，以及向您提供更便捷高效的服务，我们需要识别您的身份，当您注册我们的账户及您在使用我们的相关服务时，需要您填写、提交及/或以其他方式提供您的个人信息。</b>
                                    </dd>
                                    <dd>
                                        <b>1.1.为您注册成为我们的用户以及提供核心的服务。</b>
                                    </dd>
                                    <dd>
                                        <b>您需要向我们提供您的手机号码，我们将以此为您创建账号，如您拒绝提供将无法完成账号创建。</b>
                                    </dd>
                                    <dd>
                                        <b>您需要向我们提供您的姓名、身份证号、驾驶证、信用卡信息、面部识别特征。我们以此识别您在摩托宝的身份及完成实名认证，以为您提供摩托宝服务。如果您拒绝提供上述信息，摩托宝将无法为您提供服务。</b>
                                    </dd>
                                    <dd>
                                        <b>1.2.您可以添加紧急联系人，包括紧急联系人姓名和手机号。紧急联系人信息用于发生紧急情况时与您指定的联系人取得联系。</b>
                                    </dd>
                                    <dd>
                                        <b>1.3.您可以选择是否提供常用地址（包括家庭地址、快递地址及公司地址）。设置后您可以更便捷地填写接受服务的地点信息。</b>
                                    </dd>
                                    <dd>
                                        <b>1.4.您参加我们的市场运营活动时，我们需要您提供某些信息，可能会包含您的姓名、照片、通讯地址、联系方式、银行卡号。这些信息可以帮助我们对活动结果进行公示，对活动进行后续宣传，与您取得联系，向您发放礼品或转账等。如果您拒绝提供此类信息，可能导致无法参与相应活动，或无法收到礼品、转账，但不会影响您使用摩托宝平台提供的服务。</b>
                                    </dd>
                                    <dd>
                                        <b>1.5.您在开具发票的过程中，将需要向我们提供相关信息，如单位开票信息
                                            (包括单位名称、纳税人识别号、注册地址、注册电话、开户银行、银行账号)、邮箱、联系地址。如您拒绝提供相关信息，我们将无法向您开具发票。</b>
                                    </dd>
                                    <dd>
                                        <b>1.6.您在摩托宝进行评价的过程中，也可能会包含或者关联到您的个人信息。您可以匿名评价，在此过程中请勿留存个人信息。</b>
                                    </dd>
                                    <dd>
                                        <b>1.7.您可以选择不提供1.2至1.6的某一或某些信息，这样不会影响您使用我们的核心功能，但可能使您无法使用我们的部分特色服务。请您理解，我们使用您提供的信息是为了回应您的要求，为您享受我们提供的各项服务提供便利，完善我们的网站/客户端以及与您进行信息沟通。</b>
                                    </dd>
                                    <dd><b>2.我们在您使用服务过程中获得的信息</b></dd>
                                    <dd><b>为了提升服务质量和用户体验，我们会留存您使用服务以及相关使用方式的信息，这类信息包括：</b></dd>
                                    <dd><b>2.1.位置信息。我们将收集您的位置信息，以便您不需要手动输入地理坐标即可获得相关的服务。在您首次使用摩托宝服务前，我们会提示您选择是否允许摩托宝获取以及何种情况下可以获取您的位置信息。在您使用摩托宝服务的过程中，您可以随时通过您的设备设置功能，选择是否允许摩托宝获取以及何种情况下可以获取您的位置信息。获得您的允许后，我们会通过IP地址、GPS以及能够提供相关信息的其他传感器（如附近设备、Wi-Fi接入点和基站信息）来获取您的位置信息。如果您拒绝摩托宝获取位置信息，将需要您手动定位您的位置。</b>
                                    </dd>
                                    <dd>
                                        <b>2.2.订单信息及交易状态。我们将记录您的订单信息及交易状态。我们收集上述信息是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。</b>
                                    </dd>
                                    <dd><b>2.3.您在摩托宝进行交易支付时，如果使用第三方支付功能，摩托宝除获取您的支付工具及订单支付状态、充值信息外，不会获取其他个人信息。我们收集上述信息以核实您是否按约支付费用，维护平台交易秩序，并按照平台规则处理用户纠纷。</b>
                                    </dd>
                                    <dd><b>2.4.日志信息。为开展数据分析和更好改善平台服务，我们会收集您的日志信息，包括检索内容、IP地址、设备信息（包括设备型号、设备识别码、操作系统、分辨率、电信运营商）、位置信息。</b>
                                    </dd>
                                    <dd>
                                        <b>您提供的上述信息及上述被获取的信息，将在您使用本服务期间持续授权我们使用。除非法律对存储时间有特殊要求，在您注销账号时，我们将停止使用并匿名化上述信息。</b>
                                    </dd>
                                    <dd><b>2.5.设备信息。为了推送消息、分享信息和和图文识别、了解产品适配性、保障我们的应用安全运行，我们会通过设备信息权限收集您的设备信息(SDK版本、设备产商、设备型号、设备名称、IP地址、设备标识符(MAC/IMEI/IMSI/Android
                                        Id)、WIFI状态信息)，同时我们还会收集您的网络接入方式及类型、应用安装列表、应用崩溃记录讯息)</b></dd>
                                    <dd>
                                        <b>您提供的上述信息及上述被获取的信息，将在您使用本服务期间持续授权我们使用。除非法律对存储时间有特殊要求，在您注销账号时，我们将停止使用并匿名化上述信息。</b>
                                    </dd>
                                    <dd><b>除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括但不限于您与我们的客服团队联系时提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、合作伙伴之间互动时我们获得的相关信息。同时，为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的链接（“URL”）。</b>
                                    </dd>
                                    <dd><b>3.来自第三方的信息</b></dd>
                                    <dd><b>在您注册我们的平台账户和使用服务过程中，经您授权我们可向关联方、合作伙伴及其他独立第三方来源获得关于您的个人信息。这些个人信息包括但不限于您的账号信息、身份信息、地理位置信息、行为信息、交易信息、设备信息等。我们会将此类信息汇总，用于帮助我们向您提供更好的服务或更好地预防互联网欺诈。</b>
                                    </dd>
                                    <dd><b>您通过第三方平台使用摩托宝的服务时，摩托宝将会向第三方收集您的姓名、身份证号、驾驶证、信用卡、手机号、位置信息、订单信息以及设备号，以识别您的身份、确定您的位置并向您提供服务。摩托宝向第三方收集上述个人信息前，将对个人信息来源的合法性进行确认。</b>
                                    </dd>
                                    <dd><b>4.其他</b></dd>
                                    <dd>
                                        我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于为商业决策提供产品或服务支撑，以及改进我们的产品和服务，例如使用匿名数据进行机器学习或模型算法训练。我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
                                    </dd>
                                    <dd><b>5.征得同意的例外</b></dd>
                                    <dd>根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：<br>（1）与国家安全、国防安全有关的；<br>（2）与公共安全、公共卫生、重大公共利益有关的；<br>（3）与犯罪侦查、起诉、审判和判决执行等有关的；<br>（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br>（5）所收集的信息是您自行向社会公众公开的；<br>（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<br>（7）根据您的要求签订合同所必需的；<br>（8）用于维护服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>（9）为合法的新闻报道所必需的；<br>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；<br>（11）法律法规规定的其他情形。
                                    </dd>
                                    <dd><b>6.以上由您提供或我们收集您的信息中，可能包含您的个人敏感信息，请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本声明所述方式来处理。</b>
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>三、 设备权限调用</dt>
                                    <dd>
                                        摩托宝可能会调用您的一些设备权限，您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝摩托宝调取相应的个人信息。使用系统不同的设备，权限显示方式和关闭方式可能有所不同，具体请联系设备及系统开发方。但关闭部分功能，可能会影响到您使用账号创建、租车、交易支付服务等核心业务功能。
                                    </dd>
                                    <dd>
                                        <table border="1" class="tdac">
                                            <thead>
                                            <tr>
                                                <td>设备权限</td>
                                                <td>业务功能</td>
                                                <td>调用目的</td>
                                                <td>是否询问</td>
                                                <td>可否关闭</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>电话</td>
                                                <td>拨打电话</td>
                                                <td>用户与客服之间的联系，用户与活动方之间的联系</td>
                                                <td>首次安装进行询问</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>定位</td>
                                                <td>位置相关服务</td>
                                                <td>定位当前位置，提供精确的救援服务</td>
                                                <td>首次安装进行询问</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>存储</td>
                                                <td>用户信息存储</td>
                                                <td>使用相机拍照存储照片、数据缓存、下载资源等需要使用外部存储</td>
                                                <td>首次安装进行询问</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>摄像头</td>
                                                <td>上传图片、人脸识别需要使用相机</td>
                                                <td>拍照上传身份证、行驶证、车辆照片信息等相关图片</td>
                                                <td>调用相关功能询问</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>录音</td>
                                                <td>在线聊天</td>
                                                <td>问题上报和反馈</td>
                                                <td>在线聊天发送语音消息</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>本地网络</td>
                                                <td>全部功能</td>
                                                <td>连接网络</td>
                                                <td>调用相关功能询问</td>
                                                <td>是</td>
                                            </tr>
                                            <tr>
                                                <td>应用安装列表</td>
                                                <td>救援服务，第三方SDK</td>
                                                <td>救援服务时导航跳转第三方地图应用，第三方SDK统计、分享使用</td>
                                                <td>调用相关功能询问</td>
                                                <td>是</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>四、Cookie和同类技术</dt>
                                    <dd><b>1.Cookie</b></dd>
                                    <dd>为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储Cookie、Flash
                                        Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。借助于
                                        Cookie，网站能够存储您的偏好数据。
                                    </dd>
                                    <dd>如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。有关详情，请参见
                                        AboutCookies.org。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。
                                    </dd>
                                    <dd>2.Cookie同类技术</dd>
                                    <dd>除 Cookie外，我们还会在网站上使用网站信标、像素标签、ETag等其他同类技术。</dd>
                                    <dd>
                                        例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
                                    </dd>
                                    <dd>
                                        ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验。
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>五、您对个人信息的管理</dt>
                                    <dd>1.查询、更正和补充您的信息</dd>
                                    <dd>您有权查询、更正或补充您的信息。您可以通过以下方式进行：</dd>
                                    <dd>联系客服寻求帮助，协助您查询、更正或补充您的信息。 在您进行更新或更正前，我们可能会要求您验证自己的身份，然后再处理您的请求。</dd>
                                    <dd><b>2.删除您的个人信息</b></dd>
                                    <dd>在以下情形中，您可以向我们提出删除个人信息的请求：</dd>
                                    <dd>（1）如果我们处理个人信息的行为违反法律法规；</dd>
                                    <dd>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</dd>
                                    <dd>（3）如果我们处理个人信息的行为违反了与您的约定；</dd>
                                    <dd>（4）如果您不再使用我们的产品或服务，或您注销了账号；</dd>
                                    <dd>（5）如果我们不再为您提供产品或服务。</dd>
                                    <dd>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</dd>
                                    <dd><b>当您从我们的服务中删除信息后，由于技术延迟等原因，我们可能不会立即从备份系统中删除相应的信息。</b></dd>
                                    <dd><b>3.改变您授权同意的范围</b></dd>
                                    <dd>
                                        我们的业务功能可能需要您的个人信息才能完成（见本声明“我们向您收集个人信息的方式”部分）。除此之外，您可以通过修改个人资料或改变您的智能移动设备的设置等方式给予或收回您的授权同意（例如，您在移动设备中关闭使用位置的选项）。
                                    </dd>
                                    <dd>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</dd>
                                    <dd><b>4.注销您的账户</b></dd>
                                    <dd>您可以通过进行“摩托宝手机客户端→我的→其他服务→账户注销”操作或联系我们的客服提出申请注销您的账户。</dd>
                                    <dd>
                                        在响应您的请求前，我们可能会要求您验证自己的身份，然后再处理您的请求。在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
                                    </dd>
                                    <dd><b>5.约束信息系统自动决策</b></dd>
                                    <dd>
                                        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害摩托宝商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
                                    </dd>
                                    <dd><b>6.响应您的上述请求</b></dd>
                                    <dd>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</dd>
                                    <dd>我们将在30天内做出答复。如您不满意，还可以通过客服发起投诉。</dd>
                                    <dd>
                                        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
                                    </dd>
                                    <dd>在以下情形中，我们将无法响应您的请求：</dd>
                                    <dd>1) 与国家安全、国防安全直接相关的；</dd>
                                    <dd>2) 与公共安全、公共卫生、重大公共利益直接相关的；</dd>
                                    <dd>3) 与犯罪侦查、起诉、审判和执行判决等直接相关的；</dd>
                                    <dd>4) 有充分证据表明个人信息主体存在主观恶意或滥用权利的；</dd>
                                    <dd>5) 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</dd>
                                    <dd>6) 涉及商业秘密的。</dd>
                                    <dd><b>7.如摩托宝停止运营，</b>我们将至少提前30日发布公告，并及时停止收集个人信息。停止运营后，我们将停止对个人信息的商业化使用，并在满足法律法规规定的最短保存期后，对收集的个人信息进行删除或匿名化处理。
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>六、我们如何共享、转让、公开披露您的信息</dt>
                                    <dd><b>1.共享</b></dd>
                                    <dd>我们不会与摩托宝服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</dd>
                                    <dd>1）在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</dd>
                                    <dd>2）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</dd>
                                    <dd>3）在您主动选择情况下共享。</dd>
                                    <dd>
                                        4）与关联公司间共享：为便于我们基于摩托宝向您提供产品和服务，识别会员账号异常，保护摩托宝关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私保护声明所述目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
                                    </dd>
                                    <dd>
                                        5）为了给您提供更优质、便捷的服务，我们的产品中可能会包含以下第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）；
                                    </dd>
                                    <dd>
                                        <table border="1">
                                            <thead>
                                            <tr>
                                                <td>第三方SDK名称</td>
                                                <td>收集的个人信息</td>
                                                <td>使用目的</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>支付宝</td>
                                                <td>设备信息，银行卡，手机号，征信信息，支付信息，订单信息及交易状态</td>
                                                <td>支付宝支付用于完成交易费用支付；为用户提供芝麻免押服务。</td>
                                            </tr>
                                            <tr>
                                                <td>微信</td>
                                                <td>设备信息，支付信息，订单信息及交易状态</td>
                                                <td>微信支付用于完成交易费用支付；用户分享信息至微信</td>
                                            </tr>
                                            <tr>
                                                <td>腾讯即时通讯IM</td>
                                                <td>设备信息，设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/IP地址/GUID、SIM 卡
                                                    IMSI 信息），网络身份标识信息（IP地址）
                                                </td>
                                                <td>
                                                    用于用户在线聊天功能。腾讯即时通讯IM隐私权政策链接：<a href="https://cloud.tencent.com/document/product/269/58094">https://cloud.tencent.com/document/product/269/58094</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>百度ORC</td>
                                                <td>网络身份标识信息（IP地址）</td>
                                                <td>用于用户驾驶证识别、身份证识别服务。</td>
                                            </tr>
                                            <tr>
                                                <td>高德地图</td>
                                                <td>设备信息，位置信息（地址信息及行驶轨迹），网络身份标识信息（IP地址），网络运营商信息，加速度传感器</td>
                                                <td>提供导航服务和定位服务。高德地图隐私权政策链接：<a href="https://lbs.amap.com/pages/privacy">https://lbs.amap.com/pages/privacy</a></td>
                                            </tr>
                                            <tr>
                                                <td>友盟SDK</td>
                                                <td>收集个人信息类型：设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/IP地址/GUID、SIM
                                                    卡 IMSI 信息）、日志信息，位置信息、运行中进程信息、设备序列号
                                                </td>
                                                <td>分享信息、统计产品或服务的活跃度；统计产品或服务过程中出现的崩溃或无响应等状况，用于持续优化我们的产品和服务。
                                                    友盟隐私权政策链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>极光SDK</td>
                                                <td>
                                                    设备MAC地址、唯一设备识别码（如IMEI、IDFA）、手机的基本配置信息（如CPU、内存、屏幕、手机型号、操作系统等）、网络信息（如WIFI及蜂窝网络信息、IP地址等）、运行中进程信息、设备序列号、安装软件列表及软件相关配置信息
                                                </td>
                                                <td>用于消息推送服务。极光隐私权政策链接：<a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </dd>
                                    <dd>
                                        请您放心，我们会对上述第三方软件获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行安全检测，并要求其按照我们的服务目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。为保障您的合法权益，如您发现这类SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
                                    </dd>
                                    <dd><b>如您不再使用我们的产品或服务并注销您的个人账号，我们会按照本声明所述删除或匿名化处理上述个人信息。</b></dd>
                                    <dd>2.转让</dd>
                                    <dd>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</dd>
                                    <dd>1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</dd>
                                    <dd>
                                        2）在摩托宝服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本声明的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
                                    </dd>
                                    <dd>3.公开披露</dd>
                                    <dd>我们仅会在以下情况下，公开披露您的个人信息：</dd>
                                    <dd>1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</dd>
                                    <dd>
                                        2）如果公安、检察院、法院等相关机关指出您出现违反法律法规或严重违反摩托宝相关协议及规则的情况，或为保护摩托宝用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及摩托宝已对您采取的措施。
                                    </dd>
                                    <dd>4.共享、转让、公开披露个人信息时事先征得授权同意的例外</dd>
                                    <dd><b>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</b></dd>
                                    <dd><b>（1）与国家安全、国防安全有关的；</b></dd>
                                    <dd><b>（2）与公共安全、公共卫生、重大公共利益有关的；</b></dd>
                                    <dd><b>（3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</b></dd>
                                    <dd><b>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</b></dd>
                                    <dd><b>（5）您自行向社会公众公开的个人信息；</b></dd>
                                    <dd><b>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</b></dd>
                                    <dd>
                                        请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>七、如何保护您的个人信息</dt>
                                    <dd>1.数据安全措施</dd>
                                    <dd>
                                        为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
                                    </dd>
                                    <dd>
                                        我们通过信息接触者保密协议，纵深防护体系以及身份认证、监控、审计等各类安全机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如数据传输过程中使用加密传输协议；使用加密技术确保数据的保密性；使用受信赖的保护机制防止数据遭到恶意攻击；部署访问控制机制，确保只有授权人员才可访问个人信息；以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识；建立数据安全监控和审计制度，进行全面数据安全控制。
                                    </dd>
                                    <dd>
                                        请注意，单独的设备信息、搜索关键词信息等无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将这类非个人信息与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类设备信息将被视为个人信息。我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本声明所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
                                    </dd>
                                    <dd>
                                        2.互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄漏，请您立即根据本声明中提供的联系方式联络我们，以便我们采取相应措施。
                                    </dd>
                                    <dd>3.安全事件</dd>
                                    <dd>
                                        在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的措施、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                                    </dd>
                                    <dd>4.我们仅在本隐私保护声明所述目的所必需期间保留您的信息，除非法律法规有强制的保存期限要求。<b>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</b>
                                    </dd>
                                </dl>
                                <dl class="outer">
                                    <dt>八、您的信息如何在全球范围转移</dt>
                                    <dd>我们在中国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</dd>
                                    <dd>（1）适用的法律有明确规定；</dd>
                                    <dd>（2）获得您的明确授权；</dd>
                                    <dd>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</dd>
                                </dl>
                                <dl class="outer">
                                    <dt>九、我们如何处理未成年人的信息</dt>
                                    <dd>我们极其重视对未成年人个人信息的保护。摩托宝的服务仅面向成年人。如果您是未满18周岁的未成年人，您应立即停止使用我们的服务。</dd>
                                    <dd>我们根据法律的规定保护未成年人的个人信息。</dd>
                                </dl>
                                <dl class="outer">
                                    <dt>十、变更</dt>
                                    <dd>
                                        随着网络平台信息服务的进一步提升，我们的隐私保护制度也将随之更新。未经您明确同意，我们不会削减您按照本隐私保护声明所应享有的权利。我们会通过本手机客户端上发出更新版本、发送推送通知或以其他方式提醒您相关内容的更新，也请定期查看本页以了解我们对于隐私保护的最新措施。
                                    </dd>
                                    <dd>对于重大变更，我们还会提供更为显著的通知（包括我们会通过摩托宝客户端公示的方式进行通知甚至向您提供弹窗提示）。</dd>
                                    <dd>本政策所指的重大变更包括但不限于：</dd>
                                    <dd>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</dd>
                                    <dd>2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；</dd>
                                    <dd>3、个人信息共享、转让或公开披露的主要对象发生变化；</dd>
                                    <dd>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</dd>
                                    <dd>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</dd>
                                    <dd>6、个人信息安全影响评估报告表明存在高风险。</dd>
                                    <dd>如无特别说明，修订后的隐私保护声明自公布之日起生效。在前述情况下，若您继续使用我们的服务，即表示同意接受修改后的本隐私保护声明并受之约束。</dd>
                                </dl>
                                <dl class="outer">
                                    <dt>十一、如何联系我们</dt>
                                    <dd>任何时候如果您认为我们没有遵守这些原则，请利用电子邮件 2147592875@qq.com 通知我们，我们会尽一切努力，在合理适当的范围内立即改善问题。
                                    </dd>
                                    <dd>
                                        如果您的电话或电子邮箱发生变化，您可以按摩托宝客户端公布的联系方式通知摩托宝，以帮助我们保持您的资料的准确性。您也可以通过登录摩托宝移动客户端中自行更新您的个人信息。
                                        摩托宝欢迎您对我们的隐私保护制度给予评论并提出质疑。我们将致力于保护您的个人信息，尽全力保证这些信息的安全。
                                    </dd>
                                    <dd>请将与本声明有关的所有评论和质疑发往2147592875@qq.com 。</dd>
                                </dl>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
            <div class="mask"></div>
        </div>
    </div>
</template>

<script>
    import page_bg from '@/components/page_bg'
    import {test} from "../api/index";

    export default {

        data() {
            return {}
        },

        components: {
            page_bg
        },
        created() {
            this.$nextTick(() => {
                document.oncopy = function(e){
                    e.preventDefault();
                }
                // 禁用右键
                document.oncontextmenu = new Function("event.returnValue=false");
                // 禁用选择
                document.onselectstart = new Function("event.returnValue=false");
            });
        },
        methods: {
        },

        mounted() {
        }
    }
</script>


